// extracted by mini-css-extract-plugin
module.exports = {"main":"label-field_main__xK_HD","label":"label-field_label__3S6Ty","text":"label-field_text__nguK5"};